const footerColumns = [
  {
    title: '片库导航',
    links: [
      { label: '最新电影', href: '#library' },
      { label: '电视剧专区', href: '#tv' },
      { label: '免费电影', href: '#free' },
      { label: '口碑榜单', href: '#ranking' },
    ],
  },
  {
    title: '类型速览',
    links: [
      { label: '动作片', href: '#library' },
      { label: '科幻片', href: '#library' },
      { label: '悬疑推理', href: '#library' },
      { label: '爱情文艺', href: '#library' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '更新说明', href: '#faq' },
      { label: '选片指南', href: '#ranking' },
      { label: '回到顶部', href: '#top' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                555电影
              </span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-background-200">
              555电影专注片库资源整理，聚合电影大全、电视剧、最新电影与免费电影，
              并提供好看的电影推荐，帮你在海量内容里更快找到想看的那一部。
            </p>
            <div className="flex gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-100"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="flex flex-col gap-3">
              <h4 className="font-heading text-base font-bold text-background-50">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 555电影 · 本站为片库信息整理与推荐展示页面，内容仅供浏览参考。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span className="whitespace-nowrap">站内资讯仅供参考</span>
            <span className="whitespace-nowrap">数据展示为示例内容</span>
          </p>
        </div>
      </div>
    </footer>
  );
}